import React from 'react';
import PropTypes from 'prop-types';
import Price from '../common/Price';

const DealItemReview = ({ value, deal }) => {
  return (
    <div className="swformfield-additional-deals-lineitem__deal">
      <div className="swformfield-additional-deals-lineitem__deal--name">
        {deal.name}
      </div>
      <div className="swformfield-additional-deals-lineitem__deal--quantity">
        {value}
      </div>
      <div className="swformfield-additional-deals-lineitem__deal--total">
        <Price price={deal.price} />
      </div>
    </div>
  );
};

DealItemReview.propTypes = {
  value: PropTypes.number,
  deal: PropTypes.object
};

export default DealItemReview;
